import React from "react";
import PropTypes from "prop-types";
import _sortBy from "lodash/sortBy";
import Heading from "@components/Heading";

const Specifications = ({ groups }) => {
  const rendAttr = (attr, i, j) => (
    <tr
      key={attr.order + attr.label + i + j}
      className={`Specs-row text-sm ${
        j != 0 ? "border-gray-light border-t" : ""
      }`}
    >
      <th className="Specs-cell text-gray-1200 font-medium py-3 leading-18.2">
        {attr.label}
      </th>
      <td className="Specs-cell py-3 leading-18.2">{attr.value}</td>
    </tr>
  );

  const rendGroup = (group, renderedAttrs, i) => (
    <div key={group.order + group.name + i} className="mb-3 lg:mb-5">
      <Heading
        as="h3"
        display="h3"
        title={group.name}
        classesProp="text-red-brand mb-2 leading-20 text-xl lg:text-22px lg:leading-28.6"
      />

      <table className="Specs-table w-full table-fixed">
        <tbody>{renderedAttrs}</tbody>
      </table>
    </div>
  );

  const sortedGroups = _sortBy(groups, "order");

  const secondColumn = sortedGroups.map((group, i) => {
    if (i >= sortedGroups.length / 2) {
      const sortedAttrs = _sortBy(group.attributes, "order");
      const renderedAttrs = sortedAttrs.map((attr, j) => {
        return rendAttr(attr, i, j);
      });

      return rendGroup(group, renderedAttrs, i);
    }

    return null;
  });

  const firstColumn = sortedGroups.map((group, i) => {
    if (i < sortedGroups.length / 2) {
      const sortedAttrs = _sortBy(group.attributes, "order");
      const renderedAttrs = sortedAttrs.map((attr, j) => {
        return rendAttr(attr, i, j);
      });

      return rendGroup(group, renderedAttrs, i);
    }

    return null;
  });

  return (
    <div className="Tabs-content md:grid md:grid-cols-2 md:gap-x-20 text-left">
      <div className="Specs-column">{firstColumn}</div>
      <div className="Specs-column">{secondColumn}</div>
    </div>
  );
};

Specifications.propTypes = {
  groups: PropTypes.array.isRequired,
};

export default Specifications;
